import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import {
  RdsButtonComponent,
  RdsDividerComponent,
  RdsIconComponent,
  RdsLinkComponent,
} from '@rds/angular-components';

import { BookingSummaryComponent } from '@bookly/shared';

import { BookingRequestService } from '../../services/booking-request.service';

@Component({
  selector: 'bus-booking-request-confirmation',
  imports: [
    BookingSummaryComponent,
    RdsIconComponent,
    RdsLinkComponent,
    RouterLink,
    RdsDividerComponent,
    RdsButtonComponent,
  ],
  templateUrl: './booking-request-confirmation.component.html',
  styleUrl: './booking-request-confirmation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingRequestConfirmationComponent {
  readonly #bookingRequestService = inject(BookingRequestService);
  readonly bookingRequestData = this.#bookingRequestService.bookingRequestData;

  @Input() generalQuestionsEnabled: boolean = false;
}
